import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Link as MuiLink,
  Stack,
} from '@mui/material';
import { SignupForm } from './SignupForm';
import { useAuth } from '../../contexts/AuthContext';

export const SignupDialog = () => {
  const { signupDialogOpen, setSignupDialogOpen, setLoginDialogOpen } =
    useAuth();

  return (
    <Dialog
      open={signupDialogOpen}
      onClose={() => setSignupDialogOpen(false)}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <SignupForm afterSubmit={() => setSignupDialogOpen(false)} />
      </DialogContent>
      <Stack
        direction="column"
        spacing={1}
        alignItems="center"
        justifyContent="center"
        paddingBottom={2}
      >
        <Stack direction="row" spacing={0.5} justifyContent="center">
          <Typography variant="body2">Already have an account? </Typography>
          <MuiLink
            component="button"
            onClick={() => {
              setSignupDialogOpen(false);
              setLoginDialogOpen(true);
            }}
          >
            Log in
          </MuiLink>
        </Stack>
      </Stack>
    </Dialog>
  );
};
